import React from 'react';
import styled from 'styled-components';
import Container from 'components/Container';
import { Grid } from '@material-ui/core';
import { Title, Text } from 'components/Texts';
import ImageNotAvailable from 'assets/image-recharge-not-available.svg';
import { weight } from 'globalStyle';
import { Modal } from '../../../../../../components/Modals/Modal';
import ModalContent from '../../../../../../components/Modals/ModalContent';

export default function RechargeNotAvailable({ open, onClose, zIndex }) {
  return (
    <Modal wrap isBackground isOpen={open} handleClick={onClose} zIndex={zIndex} top="0px">
      <ModalContent width="325px" height="457px" onClose={onClose}>
        <Container>
          <HeaderImg
            alt=""
            src={ImageNotAvailable}
          />
          <Grid container direction="column" alignItems="center">
            <Title isCenter size={16} width="238px">Estamos preparando una evolución en la experiencia Bloom.</Title>
            <Text isCenter size={13} lineHeight={1.37} mt={15} mb={10} width="238px">
              Por este motivo, el servicio de recargas se encuentra temporalmente pausado mientras
              incorporamos mejoras clave.
            </Text>
            <Text isCenter weight={weight.BOLD} size={13} lineHeight={1.37} mb={24} width="238px">
              Muy pronto podrás realizar recargas nuevamente.
            </Text>
          </Grid>
        </Container>
      </ModalContent>
    </Modal>
  );
}

const HeaderImg = styled.img`
  width: 122px;
  height: 124px;
  align-self: center;
  margin-top: 10px;
  margin-bottom: 25px;
`;
